import styled from "styled-components";

export default function Toggle({
  disabled,
  value,
  setValue,
}: {
  disabled?: boolean;
  value: boolean;
  setValue: (value: boolean) => void;
}) {
  return (
    <ToggleLabel>
      <HiddenCheckbox
        type="checkbox"
        disabled={disabled}
        checked={value}
        onChange={(e) => setValue(e.target.checked)}
      />
      <Slider isChecked={value} />
    </ToggleLabel>
  );
}

const ToggleLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 19px;
`;

const HiddenCheckbox = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const Slider = styled.span<{ isChecked: boolean }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ isChecked }) => (isChecked ? "#1DA4F6" : "#e5e5e5")};
  transition: 0.4s;
  border-radius: 10px;

  &::before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
    transform: ${({ isChecked }) => (isChecked ? "translateX(21px)" : "none")};
  }
`;
